import classes from "./Article.module.css";
import { Fragment, useContext, useEffect } from "react";
import Card from "../UI/Card";

import CroatiaContext from "../../store/croatia-context";
import act1 from "../../assets/croatiaArticle/1.JPG";
import act2 from "../../assets/croatiaArticle/15.jpeg";
import act3 from "../../assets/croatiaArticle/16.jpeg";
import act4 from "../../assets/croatiaArticle/17.jpeg";
import act5 from "../../assets/croatiaArticle/18.jpeg";
import act6 from "../../assets/croatiaArticle/5.jpeg";
import act7 from "../../assets/croatiaArticle/6.jpeg";
import act8 from "../../assets/croatiaArticle/7.jpeg";
import act9 from "../../assets/croatiaArticle/8.jpeg";

import act10 from "../../assets/croatiaArticle/croatia_act.MP4";

import pdf1 from "../../assets/croatiaArticle/pdfs/Gra poszukiwanie skarbu_Sanja.pdf";
import pdf2 from "../../assets/croatiaArticle/pdfs/Gry miejskie_Sanja.pdf";
import pdf3 from "../../assets/croatiaArticle/pdfs/Gry na przełamanie lodów_Sanja.pdf";
import pdf5 from "../../assets/croatiaArticle/pdfs/Przepisy_Sanja.pdf";
import pdf6 from "../../assets/croatiaArticle/pdfs/Słowniczek_Sanja.pdf";

const CroatiaArticle = (props) => {
  const croCtx = useContext(CroatiaContext);

  useEffect(() => {
    document
      .getElementById(props.id)
      .scrollIntoView({ behavior: "smooth", block: "start" });
  }, [props.id]);

  return (
    <Fragment>
      <p className="main" id="act"></p>
      <Card>
        <div>
          <h1 className={classes.header}>School Project Activities</h1>
          <p className={classes.text}>{croCtx.activities[0]}</p>
          <div className={classes.center}>
            <img className={classes.single} src={act1} alt="" />
            <p>Exhibition</p>
          </div>
          <h2 className={classes.header}>Parents report</h2>
          <h3 className={classes.header}>Šurina family</h3>
          <p className={classes.text}>{croCtx.activities[1]}</p>
          <h3 className={classes.header}>Margita</h3>
          <p className={classes.text}>{croCtx.activities[2]}</p>
          <h3 className={classes.header}>Krešimir & Mirna Vrbanac</h3>
          <p className={classes.text}>{croCtx.activities[3]}</p>
          <h2 className={classes.header}>Memories</h2>
          <div className={classes.center}>
            <video className={classes.video} controls>
              <source src={act10} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <h2 className={classes.center}>
            <a
              href="https://radio.hrt.hr/slusaonica/reci-nesto?epizoda=202205182015"
              target="_blank"
              rel="noreferrer"
            >
              Reci nešto - Hrvatski radio - link
            </a>
          </h2>
        </div>
      </Card>

      <Card>
        <div className={classes.center}>
          <h1 className={classes.header}>Ice Breaker Games</h1>
          <h2 className={classes.header}>
            All materials can be downloaded from Results section
          </h2>
          <div className={classes.frame}>
            <iframe
              title={"iframe"}
              src={pdf3}
              className={classes.iframe}
              width="100%"
              height="100%"
            >
              <div>No PDF viewer available</div>
            </iframe>
          </div>
        </div>

        <div className={classes.center}>
          <h1 className={classes.header}>Turkey with dumplings - recipe</h1>
          <div className={classes.frame}>
            <iframe
              title={"iframe"}
              src={pdf5}
              className={classes.iframe}
              overflow="visible"
              width="100%"
              height="100%"
            >
              <div>No PDF viewer available</div>
            </iframe>
          </div>
        </div>
      </Card>

      <p className="main" id="meet"></p>
      <Card>
        <div>
          <h1 className={classes.header}>Project Meeting</h1>
          <h2>
            <a
              href="https://www.youtube.com/watch?v=gnHn7BsDuMA"
              target="_blank"
              rel="noreferrer"
            >
              Meeting in Croatia - Video
            </a>
          </h2>
        </div>
        <div className={`${classes.images} ${classes.center}`}>
          <article>
            <img className={classes.image} src={act2} alt="" />
          </article>
          <article>
            <img className={classes.image} src={act3} alt="" />
          </article>
        </div>
        <div className={`${classes.images} ${classes.center}`}>
          <article>
            <img className={classes.image} src={act4} alt="" />
          </article>
          <article>
            <img className={classes.image} src={act5} alt="" />
          </article>
        </div>
        <div className={`${classes.images} ${classes.center}`}>
          <article>
            <img className={classes.image} src={act6} alt="" />
          </article>
          <article>
            <img className={classes.image} src={act7} alt="" />
          </article>
        </div>
        <div className={`${classes.images} ${classes.center}`}>
          <article>
            <img className={classes.image} src={act8} alt="" />
          </article>
          <article>
            <img className={classes.image} src={act9} alt="" />
          </article>
        </div>
        <div className={classes.center}>
          <h1 className={classes.header}>City Games</h1>
          <div className={classes.frame}>
            <iframe
              title={"iframe"}
              src={pdf2}
              className={classes.iframe}
              width="100%"
              height="100%"
            >
              <div>No PDF viewer available</div>
            </iframe>
          </div>
        </div>
        <div className={classes.center}>
          <h1 className={classes.header}>Treasure Hunt</h1>
          <div className={classes.frame}>
            <iframe
              title={"iframe"}
              src={pdf1}
              className={classes.iframe}
              width="100%"
              height="100%"
            >
              <div>No PDF viewer available</div>
            </iframe>
          </div>
        </div>
        <div className={classes.center}>
          <h1 className={classes.header}>Phrase Book</h1>
          <div className={classes.frame}>
            <iframe
              title={"iframe"}
              src={pdf6}
              className={classes.iframe}
              width="100%"
              height="100%"
            >
              <div>No PDF viewer available</div>
            </iframe>
          </div>
        </div>
      </Card>
    </Fragment>
  );
};

export default CroatiaArticle;
